class TrueCarSearch {
    constructor(trueCarSearchComponents) {
        trueCarSearchComponents.forEach((trueCarSearchComponent) => {
            const form = trueCarSearchComponent.querySelector('.truecar__form');

            form.addEventListener('submit', (e) => {
                e.preventDefault();

                this.clearError(form.querySelector('.error'));
                this.search(form);            
            });
        });
    }

    clearError = (el) => {
        el.innerHTML = '';
        el.classList.add('d-none');
    }

    throwError = (message, el, input = null) => {       
        el.innerHTML = message;
        el.classList.remove('d-none');
        if (input) {
            input.focus();
        }
    }

    validateZip = (zip) => {
        return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
    }

    getSearchType = (radios) => {
        let type;
        radios.forEach((radio) => {
            console.log(radio.value);
            if (radio.checked) {
                type = radio.value;
            }
        });

        return type;
    }

    search = (form) => {
        const searchTypeRadios = form.querySelectorAll('.search-type');
        const makeId = form.querySelector('.make').value.split("|")[0];
        const makeName = form.querySelector('.make').value.split("|")[1];
        const zip = form.querySelector('.zip').value;
        const searchType = this.getSearchType(searchTypeRadios);

        if (this.validateZip(zip)) {

            console.log(searchType);

            switch (searchType) {
                case "new":
                    window.open(`https://esfcu.truecar.com/combined-new.service?makeId=${makeId}&postalCode=${zip}`, '_blank');
                    break;

                case "used":
                    window.open(`https://esfcu.truecar.com/used-cars-for-sale/listings/${makeName}/location-${zip}`, '_blank');
                    break;

                default:
                    
                    this.throwError("Please select a search type.", form.querySelector('.error'), searchTypeRadios[0]);
                    break;
            }
        }
        else {
            this.throwError("Invalid ZIP Code.", form.querySelector('.error'), form.querySelector('.zip'));
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const trueCarSearchComponents = document.querySelectorAll('.truecar');
    if (trueCarSearchComponents) {
        new TrueCarSearch(trueCarSearchComponents);
    }
});